import React, { useState, useEffect } from 'react';
import LessonLayout from '../components/LessonLayout';
import { Card, Row, Col, Alert, Button, Form } from 'react-bootstrap';

const Lesson07_Forms = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    country: 'India',
    gender: '',
    subscribe: false,
    skills: []
  });

  useEffect(() => {
    console.log('📖 Lesson 07: Forms & Controlled Components - Loaded');
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    console.log(`✏️ Form Input Changed: ${name} = ${value}`);
    setFormData({ ...formData, [name]: value });
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    console.log(`☑️ Checkbox Changed: ${name} = ${checked}`);
    setFormData({ ...formData, [name]: checked });
  };

  const handleSkillsChange = (e) => {
    const { value, checked } = e.target;
    let newSkills = [...formData.skills];
    if (checked) {
      newSkills.push(value);
    } else {
      newSkills = newSkills.filter(skill => skill !== value);
    }
    console.log('🎯 Skills Updated:', newSkills);
    setFormData({ ...formData, skills: newSkills });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('📤 Form Submitted:', formData);
    alert('Form submitted! Check console for data.');
  };

  return (
    <LessonLayout 
      lessonNumber={7}
      title="Forms & Controlled Components" 
      description="Master form handling with controlled components"
    >
      <Alert variant="success">
        <strong>What You'll Learn:</strong>
        <ul className="mb-0 mt-2">
          <li>Controlled vs uncontrolled components</li>
          <li>Handling text inputs, textareas, selects</li>
          <li>Radio buttons and checkboxes</li>
          <li>Form submission and validation</li>
        </ul>
      </Alert>

      <Row className="mt-4">
        <Col md={6}>
          <Card>
            <Card.Header>Controlled Form Example</Card.Header>
            <Card.Body>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Enter your name"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="Enter your email"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Message</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="Your message"
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Country</Form.Label>
                  <Form.Select name="country" value={formData.country} onChange={handleInputChange}>
                    <option value="India">India</option>
                    <option value="USA">USA</option>
                    <option value="UK">UK</option>
                    <option value="Canada">Canada</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Gender</Form.Label>
                  <div>
                    <Form.Check
                      type="radio"
                      label="Male"
                      name="gender"
                      value="male"
                      checked={formData.gender === 'male'}
                      onChange={handleInputChange}
                      inline
                    />
                    <Form.Check
                      type="radio"
                      label="Female"
                      name="gender"
                      value="female"
                      checked={formData.gender === 'female'}
                      onChange={handleInputChange}
                      inline
                    />
                  </div>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Label>Skills</Form.Label>
                  <div>
                    <Form.Check
                      type="checkbox"
                      label="React"
                      value="React"
                      checked={formData.skills.includes('React')}
                      onChange={handleSkillsChange}
                    />
                    <Form.Check
                      type="checkbox"
                      label="JavaScript"
                      value="JavaScript"
                      checked={formData.skills.includes('JavaScript')}
                      onChange={handleSkillsChange}
                    />
                    <Form.Check
                      type="checkbox"
                      label="Node.js"
                      value="Node.js"
                      checked={formData.skills.includes('Node.js')}
                      onChange={handleSkillsChange}
                    />
                  </div>
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Check
                    type="checkbox"
                    label="Subscribe to newsletter"
                    name="subscribe"
                    checked={formData.subscribe}
                    onChange={handleCheckboxChange}
                  />
                </Form.Group>

                <Button type="submit" variant="primary">Submit Form</Button>
              </Form>
            </Card.Body>
          </Card>
        </Col>

        <Col md={6}>
          <Card>
            <Card.Header>Current Form State</Card.Header>
            <Card.Body>
              <pre className="code-example">{JSON.stringify(formData, null, 2)}</pre>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Alert variant="warning" className="mt-4">
        <strong>💡 Key Concepts:</strong>
        <ul className="mb-0">
          <li>Controlled components: React controls the form input values</li>
          <li>Use <code>value</code> and <code>onChange</code> for inputs</li>
          <li>Use <code>checked</code> for checkboxes and radios</li>
          <li>Prevent default form submission with <code>e.preventDefault()</code></li>
        </ul>
      </Alert>
    </LessonLayout>
  );
};

export default Lesson07_Forms;
